export const CAROUSEL_TEMPLATE_TYPES = {
  VEHICLE_DETAILS: 'vehicle-details',
  MORE_LIKE_THIS: 'more-like-this',
};
